export default "__VITE_ASSET__DRzzIMCV__"